<template>
  <div>
    <div class="mb-2">
      <am-button
        class="farm-back-btn"
        variant="outline-primary"
        icon="ArrowLeftIcon"
        label="Back to production"
        @click="$router.push({ name: 'production' })"
      />
    </div>
    <farms-index :member-id="memberId" />
  </div>
</template>

<script>
import AmButton from '@/farmbusiness/components/AmButton.vue'
import FarmsIndex from '@/views/farm-manager/farms/Index.vue'

export default {
  name: 'ProductionFarmerFarms',
  components: { AmButton, FarmsIndex },
  computed: {
    memberId() {
      return this.$route.params.memberId
    },
  },
}
</script>

<style scoped>
.farm-back-btn {
  white-space: nowrap;
}

.farm-back-btn >>> .btn,
.farm-back-btn >>> div {
  white-space: nowrap;
}
</style>
